/**
 * 
 * @param {string} pageType values: pdp, checkout
 * @returns 
 */
Core.StockIntegration = function(pageType) {
    var PAGE_TYPE = {
        PDP: 'pdp',
        CHECKOUT: 'checkout',
        CO_AGEDCARE: 'co_agedcare',
    }
    var CLS_HIDE = 'd-none';
    var CLS_CHECKED = 'has-checked';
    var CLS_LOCATION = 'has-location';

    var currentSku = '';
    var currentMainSku = '';
    var $currentVariant = '';
    var $locationPopup = $('#stock-location-popup');
    var isPdp = pageType === 'pdp';
    var isAgedCare = Core.Util.isAgedCare();
    
    var $page = getPageType();
    var isWholesale = $page.hasClass('product-detail--wholesale');

    function getPageType() {
        switch (pageType) {
            case PAGE_TYPE.PDP:
            default:
                return $('#product-detail');
            case PAGE_TYPE.CHECKOUT:
                return $('#portal-checkout');
            case PAGE_TYPE.CO_AGEDCARE:
                return $('#cart');
        }
    }

    function getParentSelector($btn) {
        switch (pageType) {
            case PAGE_TYPE.PDP:
            default:
                var $parent = $btn.closest('.product-details__variant');
                return $parent.length > 0 ? $parent : $btn.closest('.product-details__columnwrap');
            case PAGE_TYPE.CHECKOUT:
                return $btn.closest('.portal-checkout__stock');
            case PAGE_TYPE.CO_AGEDCARE:
                return $btn.closest('.product-row');
        }
    }

    function handleCheckStock() {
        var $stockCheckBtn = $('.stock-checkBtn');
        if ($stockCheckBtn.length === 0) return;
        
        $stockCheckBtn.on('click', function(e) {
            var $btn = $(this);
            var $parent = getParentSelector($btn);
            
            setVariables($parent);
            
            // if postcode is already set, check stock directly
            if ($page.attr('data-postcode')) {
                checkStock(false);
            } else {
                openPopup();
            }
        });
    }

    function handleChangeSuburb() {
        var $changeSuburbBtn = $('.stock-changeSuburbBtn');
        if ($changeSuburbBtn.length === 0) return;

        $changeSuburbBtn.on('click', function(e) {
            e.preventDefault();
            var $btn = $(this);
            var $parent = getParentSelector($btn);
            setVariables($parent);
            openPopup();
        });
    }

    function setVariables($parent) {
        var sku = $parent.find('[name="qty"]').data('id');
        var mainSku = $parent.find('.mainProdSku').val();

        currentSku = sku;
        currentMainSku = mainSku;
        $currentVariant = $parent;
        // value is empty on variant-selector, so set to global window variable
        window.currentSku = sku;
        window.currentMainSku = mainSku;
        window.$currentVariant = $parent;
    }

    function openPopup() {
        var popup = new ClientPopup($locationPopup, {title: 'Enter your postcode for local stock availability'});
        popup.init();
    }

    function handleSetLocation() {
        var $setLocationBtn = $('.stock-setLocationBtn');
        if ($setLocationBtn.length === 0) return;

        $setLocationBtn.on('click', function(e) {
            e.preventDefault();
            var $btn = $(this);
            var $form = $btn.closest('form');

            $page.attr({
                'data-postcode': $form.find('.addressAutocomplete-postcode').val(),
                'data-suburb': $form.find('.addressAutocomplete-suburb').val(),
                'data-state': $form.find('.addressAutocomplete-state').val(),
            });

            if (!$form.valid()) return;

            $('.stock-local').addClass(CLS_LOCATION);
            checkStock(true);
        });
    }

    function checkStock(setLocation) {
        // get location from page element
        var api = $page.data('check-local-stock-api');
        if (!api) {
            console.log('Please provide the api url for stock check (data-check-local-stock-api)');
            return;
        }

        var _$currentVariant = $currentVariant || window.$currentVariant;
        var location = {
            suburb: $page.attr('data-suburb'),
            state: $page.attr('data-state'),
            postCode: $page.attr('data-postcode'),
        };

        if (!location.postCode) {
            openPopup();
            return;
        }

        // make sure it select the first one cause some producst has children within the current variant selector
        var $loader = _$currentVariant.find('.loading-overlay').first();
        var $wrap = _$currentVariant.find('.stock-wrap').first();
        var $local = $wrap.find('.stock-local');
        var $stockCheckBtn = _$currentVariant.find('.stock-checkBtn').first();
        var $error = setLocation ? $('.stock-setLocationError') : _$currentVariant.find('.stock-error').first();    

        if (setLocation) {
            Core.ShowPageLoading();
        } else {
            $stockCheckBtn.prop('disabled', true);
            $loader.removeClass(CLS_HIDE);
        }

        $error.addClass(CLS_HIDE);

        var variants = [];
        if (isPdp) {
            if (isWholesale) {
                $('#variants .product-details__variant--row').each(function(i, row) {
                    variants.push({
                        qty: row.querySelector('input[name="qty"]')?.value || 1,
                        sku: row.dataset.id,
                    });
                });
            } else {
                variants.push({
                    qty: 1,
                    sku: currentSku || window.currentSku,
                    mainsku: currentMainSku || window.currentMainSku,
                });
            }
        } else {
            // push all variants for checkout page
            if (isAgedCare) {
                $('.product-row').each(function(i, row) {
                    variants.push({
                        qty: row.querySelector('input[name="qty"]')?.value || 1,
                        sku: row.dataset.id,
                    });
                });
            } else {
                $('.portal-checkout__row.buy-row').each(function(i, row) {
                    variants.push({
                        qty: row.querySelector('input.portal-checkout__purchase-qty')?.value || 1,
                        sku: row.dataset.id,
                    });
                });
            }
        }

        $.ajax({
            url: api,
            data: {
                variants: variants,
                location: location,
                setLocation: setLocation,
            },
            type: 'POST',
            dataType: 'json',
            success: function(data) {     
                if (data.isSuccess) {
                    var stockData = data.stocks.length > 0 && 
                        (isPdp && !isWholesale) ? data.stocks[0] : data.stocks; // get first item for pdp

                      // Reset all local stock info
                      if (setLocation) {
                        $('.stock-local').removeClass(CLS_CHECKED);
                        $('.stock-checkBtn').removeClass(CLS_HIDE);
                    }
                    
                    if (isPdp) {
                        isWholesale ? 
                            onSuccessCheckStock(location, stockData) :
                            onSuccessCheckStockPdp(location, $local, stockData);
                    } else {
                        onSuccessCheckStock(location, stockData);
                    }

                    // Close popup 
                    if (setLocation) {
                        $locationPopup.data('kendoWindow').close();
                        Core.HidePageLoading();
                    }
                } else {
                    $error.html(data.message);
                    $error.removeClass(CLS_HIDE);
                }
            },
            error: function(xhr, ajaxOptions, thrownError) {        
                $error.removeClass(CLS_HIDE);
                console.log('error', xhr, ajaxOptions, thrownError);
                Core.HidePageLoading();
            },
            complete: function() {
                $stockCheckBtn.prop('disabled', false);
                $loader.addClass('d-none');
            }
        });
    }

    function onSuccessCheckStockPdp(location, $local, stockData) {
        // show error if value is empty
        if (stockData.value === '') {
            $local.find('.stock-error').removeClass(CLS_HIDE);
            return;
        }

        $('.stock-checkBtn').text(`Check local stock for ${location.suburb} ${location.postCode}`);
        $local.find('.stock-status').css('background-color', stockData.colour);
        $local.find('.stock-message').text(`${stockData.value} for ${location.suburb} ${location.postCode}`);
        $local.find('.stock-checkBtn').addClass(CLS_HIDE);
        $local.addClass(CLS_CHECKED);
    }

    // for checkout page, pdp-wholesale
    function onSuccessCheckStock(location, stockData) {
        if (isWholesale) {
            $('.stock-checkBtn').html(`Showing stock for ${location.suburb} ${location.postCode}`);
            $('.stock-checkBtn').addClass('pe-none');
        } else {
            $('.stock-checkBtn').html(`Check local stock for ${location.suburb} ${location.postCode}`);
        }
        
        if (stockData.length > 0) {
            stockData.forEach(function(item, index) {
                var $row = 
                    isWholesale ? $(`.product-details__variant--row[data-id="${item.sku}"]`) :
                    isAgedCare ? $(`.product-row[data-id="${item.sku}"]`) : 
                    $(`.portal-checkout__row[data-id="${item.sku}"]`);
                if ($row.length === 0) return;

                if (item.value === '') {
                    $row.find('.stock-error').removeClass(CLS_HIDE);
                    return;
                }

                var locationTemplate = isWholesale
                    ? `<span class="px-0">${location.suburb} ${location.postCode}</span>`
                    : `<a href="#" role="button" class="stock-changeSuburbBtn btn-link px-0">${location.suburb} ${location.postCode}</a>`;

                var $local = $row.find(`.stock-local`);
                $local.find('.stock-status').css('background-color', item.colour);
                $local.find('.stock-message').html(`${item.value} for ${locationTemplate}`);
                $local.addClass(CLS_CHECKED);
                $row.find('.stock-checkBtn').addClass(CLS_HIDE);
                $row.find('.stock-updateBtn').removeClass(CLS_HIDE);

                $local.on('click', '.stock-changeSuburbBtn', function(e) {
                    e.preventDefault();
                    var $btn = $(this);
                    var $parent = getParentSelector($btn);
                    setVariables($parent);
                    openPopup();
                });
            });
        }
    }

    // async api call to check stock on page load
    function checkStockAsyncPdp(isComplexVariant) {
        if (!Core.Util.isCheckLocalStockAsync()) return;

        var api = $page.data('check-local-stock-api');
        if (!api) {
            console.log('Please provide the api url for stock check (data-check-local-stock-api)');
            return;
        }

        var location = {
            suburb: $page.attr('data-suburb'),
            state: $page.attr('data-state'),
            postCode: $page.attr('data-postcode'),
        };

        var variants = [];
        var $row = isComplexVariant ? $('#complexVariant .product-details__variant') : $('#variants .product-details__variant--row');
        $row.each(function(i, row) {
            variants.push({
                qty: row.querySelector('input[name="qty"]')?.value || 1,
                sku: row.dataset.id,
            });
        });

        var retry = 0;
        var doCheckStock = function() {
            $.ajax({
                url: api,
                data: {
                    variants: variants,
                    location: location,
                    setLocation: false,
                },
                type: 'POST',
                dataType: 'json',
                success: function(data) {     
                    if (data.isSuccess) {
                        var stockData = data.stocks;
                        
                        if (stockData.length > 0) {
                            stockData.forEach(function(item, index) {
                                var $row = $(`.product-details__variant--row[data-id="${item.sku}"]`);
                                if ($row.length === 0) return;
                
                                // keep stock-national if no value
                                if (Core.Util.isEmpty(item.value)) {
                                    return;
                                }
                
                                var $local = $row.find(`.stock-local`);
                                $local.find('.stock-status').css('background-color', item.colour);
                                $local.find('.stock-message').html(`${item.value}`);
                                $local.addClass(CLS_CHECKED);
                                $row.find(`.stock-national`)?.addClass(CLS_HIDE);
                            });
                        }
                    } else {
                        console.log('error', data.message);
                        retryCheckStock();
                    }
                },
                error: function(xhr, ajaxOptions, thrownError) {        
                    console.log('error', xhr, ajaxOptions, thrownError);
                    retryCheckStock();
                }
            });
        };

        var retryCheckStock = function() {            
            if (retry === 0) {
                setTimeout(doCheckStock, 500);
                retry++;
            }
        };

        if (variants.length > 0) {
            doCheckStock();
        }
    }

    var m = {
        init: function() {
            handleCheckStock();
            handleChangeSuburb();
            handleSetLocation();
            checkStockAsyncPdp();
        },
        updateStock: function(setLocation, $parent) {
            setVariables($parent);
            checkStock(setLocation);
        },
        changeSuburb: function($parent) {
            setVariables($parent);
            openPopup();
        },
        checkStockAsyncPdp: checkStockAsyncPdp,
    };

    return m;
};